/** @format */

export const utilityConvertAreaLabelToID = (area: { poiName: string; latitude: number; longitude: number }): string =>
  area.poiName.toLocaleLowerCase().replace(/\s/g, '');
